export class MessageModel {
  constructor(
    public status: string,
    public message: string,
  ) {}
}
